var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.844 27.5H6.065V11.647h6.625c1.502 0 2.68.355 3.538 1.065.857.704 1.285 1.667 1.285 2.89 0 .835-.27 1.578-.813 2.23-.542.652-1.212 1.04-2.01 1.165v.197c1.069.103 1.937.506 2.604 1.209.666.696 1 1.56 1 2.593 0 1.391-.488 2.49-1.462 3.296-.967.805-2.296 1.208-3.988 1.208zM8.9 13.899v4.416h2.736c1.003 0 1.765-.186 2.285-.56.527-.38.79-.93.79-1.648 0-.696-.237-1.238-.713-1.626-.476-.388-1.143-.582-2-.582H8.9zm0 11.349h3.296c1.047 0 1.842-.209 2.384-.626.542-.425.813-1.04.813-1.846 0-.791-.282-1.392-.846-1.802-.557-.41-1.377-.615-2.461-.615H8.9v4.889zm15.535-6.79h.483l5.955-6.811h3.251l-6.8 7.712L34.63 27.5h-3.494l-6.207-6.79h-.494v6.79H21.6V11.647h2.835v6.811z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026FF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.05d1b4739f036edfabc529270f34bb8d.svg";
export { ForwardRef as ReactComponent };